import { ISavedColor } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface ProjectColorsProviderState {
  addSavedColor: (id: string, name: string, color: string) => void;
  deleteSavedColor: (id: string) => void;
  updateSavedColor: (id: string, name: string, color: string) => void;
  getAllSavedColors: () => ISavedColor[];
}

export class ProjectColorsProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  ProjectColorsProviderState
> {
  static defaultState: ProjectColorsProviderState = {
    addSavedColor: () => {},
    deleteSavedColor: () => {},
    updateSavedColor: () => {},
    getAllSavedColors: () => []
  };

  getProviderValues = (): ProjectColorsProviderState => {
    return {
      addSavedColor: this.addSavedColor,
      deleteSavedColor: this.deleteSavedColor,
      updateSavedColor: this.updateSavedColor,
      getAllSavedColors: this.getAllSavedColors
    };
  };

  addSavedColor = (id: string, name: string, color: string) => {
    const project = this.state.project;
    if (!project.savedColors) {
      project.savedColors = [];
    }
    if (project.savedColors?.some((x) => x.name === name)) {
      KMainFunctions.displayWarningNotification("This color name already exists.");
      return;
    }

    project.savedColors.push(
      _.cloneDeep({
        id,
        name,
        color
      })
    );
    this.partial.projectProvider.updateProject(project);
  };

  deleteSavedColor = (id: string) => {
    const project = this.state.project;
    if (project.savedColors) {
      project.savedColors = project.savedColors.filter((x) => x.id !== id);
    }
    this.partial.projectProvider.updateProject(project);
  };

  updateSavedColor = (id: string, name: string, color: string) => {
    const project = this.state.project;
    if (project.savedColors) {
      const colorIndex = project.savedColors.findIndex((x) => x.id === id);
      if (colorIndex !== -1) {
        project.savedColors[colorIndex] = {
          id,
          name,
          color
        };
        this.partial.projectProvider.updateProject(project);
      }
    }
  };

  getAllSavedColors = () => {
    const project = this.state.project;
    if (project.savedColors) {
      return project.savedColors;
    }
    return [];
  };
}
